import routeDefinitions from "./screenRoutes.json" with { type: "json" };

export interface SupportError {
  message: string;
  status: number | null;
  endpoint: string;
  request_id: string | null;
  occurred_at: string;
}
let lastError: SupportError | null = null;
let sessionAvailable = false;
export function setSupportSession(available: boolean) {
  sessionAvailable = available;
}
export function hasSupportSession() {
  return sessionAvailable;
}
export const SUPPORT_ERROR_EVENT = "avm-support-error";
export const SUPPORT_OPEN_EVENT = "avm-support-open";
export const SUPPORT_QUESTION_EVENT = "avm-support-question";
export function openSupportQuestion() {
  window.dispatchEvent(new Event(SUPPORT_QUESTION_EVENT));
}
export function rememberSupportError(error: SupportError) {
  lastError = error;
  window.dispatchEvent(new CustomEvent(SUPPORT_ERROR_EVENT, { detail: error }));
}
export function recentSupportError(now = Date.now()): SupportError | null {
  return lastError && now - Date.parse(lastError.occurred_at) <= 5 * 60_000
    ? lastError
    : null;
}
export function clearSupportError() {
  lastError = null;
}
export function openSupport(error?: SupportError) {
  window.dispatchEvent(new CustomEvent(SUPPORT_OPEN_EVENT, { detail: error }));
}
export function shortUserAgent(agent: string): string {
  const platform = /Android/.test(agent)
    ? "Android"
    : /iPhone|iPad/.test(agent)
      ? "iOS"
      : /Windows/.test(agent)
        ? "Windows"
        : /Macintosh/.test(agent)
          ? "macOS"
          : /Linux/.test(agent)
            ? "Linux"
            : "Preglednik";
  const browser = agent.match(/(Edg|Firefox|Chrome)\/(\d+)/);
  const safari = agent.match(/Version\/(\d+).*Safari/);
  return `${platform}${browser ? `, ${browser[1] === "Edg" ? "Edge" : browser[1]} ${browser[2]}` : safari ? `, Safari ${safari[1]}` : ""}`;
}
export const screenRoutes = routeDefinitions.map(route => ({
  ...route,
  pattern: new RegExp(route.pattern),
}));
export function supportScreen(path: string) {
  return screenRoutes.find(route => route.pattern.test(path));
}
export function supportScreenName(path: string, heading = ""): string {
  const screen = supportScreen(path)?.name ?? "Aplikacija";
  const number = /^\/nabava\/[0-9a-f-]+$/i.test(path)
    ? document
        .querySelector(".avm-pagehead")
        ?.textContent?.match(/NAR-\d{4}-\d+/)?.[0]
    : null;
  if (screen === "Narudžbe" && number) return `${screen} → ${number}`;
  return heading && heading !== screen
    ? `${screen} → ${heading.slice(0, 160)}`
    : screen;
}
export function supportContext() {
  return {
    screen_name: supportScreenName(
      window.location.pathname,
      document.querySelector("main h1")?.textContent?.trim() ?? "",
    ),
    url: window.location.pathname,
    user_agent: shortUserAgent(navigator.userAgent),
    last_error: recentSupportError(),
  };
}
